import axios from "axios";

// 根据环境设置不同的baseURL
const isDevelopment = process.env.NODE_ENV === 'development';
const baseURL = isDevelopment ? '/dev-api' : 'https://official-api.hsmap.com';

// 创建axios实例
const http = axios.create({
  baseURL: baseURL,
  timeout: 5000,
});

// 请求拦截器 - 自动添加语言参数
http.interceptors.request.use(
  (config) => {
    // 获取当前语言设置
    const currentLanguage = localStorage.getItem('preferred-language') || 'zh-CN';
    
    // 如果是GET请求，在params中添加语言参数
    if (config.method === 'get' || config.method === 'GET') {
      config.params = {
        ...config.params,
        language: currentLanguage
      };
    }
    
    // 如果是POST请求，在data中添加语言参数
    if ((config.method === 'post' || config.method === 'POST') && config.data) {
      if (config.data instanceof FormData) {
        // 如果是FormData，直接追加
        config.data.append('language', currentLanguage);
      } else {
        // 如果是普通对象，合并
        config.data = {
          ...config.data,
          language: currentLanguage
        };
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;
